import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionFolderService } from '../../shared/services/index';
import { InspectionFolder } from '../../shared/models/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './edit.component.html',
    standalone: false
})
export class InspectionFolderEditPageComponent extends BaseModalPageComponent implements OnInit {
  folder: InspectionFolder;
  inspectionId: string;
  sectionId: string;
  folderId: string;
  public processing = false;

  constructor(
    public folderService: InspectionFolderService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const sectionId = params['sectionId'];
      if (sectionId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.sectionId = sectionId;
      this.folderId = params['folderId'];

      this.initData();
    });
  }

  saveInspectionFolder(folder: InspectionFolder): void {
    this.processing = true;
    this.folderService
      .updateProperties(this.inspectionId, this.sectionId, this.folderId, {
        name: folder.name,
        description: folder.description
      })
      .subscribe((el) => {
        this.processing = false;
        this.folder = el;
        this.goToBack();
      });
  }

  cancel(): void {
    this.goToBack();
  }

  initData(): void {
    this.folderService.getFolder(this.inspectionId, this.folderId).subscribe((el) => {
      this.folder = el;
      this.cdf.detectChanges();
    });
  }
}
